import axios from "axios";

import type { AsyncDownloadResponse } from "./downloads";
import type { MovementFilter } from "./type";

export interface ViewsResponse {
  status: string;
  data: {
    views: View[];
  };
}

export interface View {
  _id: string;
  name: string;
  listOrder?: number;
}

export async function fetchViews() {
  const { data } = await axios.get<ViewsResponse>("/match/view");
  return data;
}

export interface ViewColumn {
  id: string;
  label: string;
  dataType: "string" | "double" | "date";
  outputFormat?: {
    thousandsSeparator?: string;
    decimalSeparator?: string;
    decimalPlaces?: number;
  };
}

export interface ViewRow {
  label: string;
  [metricId: string]: string;
}

export interface ViewGeneratedResponse {
  status: string;
  data: {
    columns: ViewColumn[];
    rows: ViewRow[];
  };
}

export interface DateRange {
  startDate: string;
  endDate: string;
}

export interface GenerateViewParams {
  dateRange?: DateRange;
}

// The view download persists `filters` only for the Download Center snapshot (the
// query itself runs off `dateRange`), so we forward the date range as a labeled
// filter to surface it in the "Ver filtros" modal.
export interface DownloadViewParams extends GenerateViewParams {
  filters?: MovementFilter[];
}

export async function generateView(viewId: string, body?: GenerateViewParams) {
  const { data } = await axios.post<ViewGeneratedResponse>(
    `/match/view/${viewId}/generate`,
    body,
  );
  return data;
}

export async function downloadView(viewId: string, body?: DownloadViewParams) {
  const { data } = await axios.post<AsyncDownloadResponse>(
    `/match/view/${viewId}/download/async`,
    body,
  );
  return data;
}
